import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Sort } from "@angular/material/sort";
import { EvaluationService } from "@app-services/evaluation.service";
import { EvaluationVehicle } from "@app-model/evaluation";
import { BuyPriceDetails, SellPriceDetails } from "@app-model/pricing";
import { Vehicle } from "@app-model/vehicle";
import { SessionService } from "@app/store/session/session.service";
import { UserInfo } from "@app/store/session/session.store";

@Component({
  selector: "app-evaluation-price-modal",
  templateUrl: "./evaluation-price-modal.component.html",
  styleUrls: ["./evaluation-price-modal.component.scss"],
})
export class EvaluationPriceModalComponent implements OnInit {
  vehicle?: EvaluationVehicle | Vehicle;

  filter: any = {
    cityId: "string",
    dealerFilter: "ALL",
    evalDealerId: "string",
    modelFilter: "MODEL_YEAR",
    modelId: "string",
    modelYear: 0,
    oemDealerId: "string",
    region: "COUNTRY",
    startDate: "2020-06-01T16:50:21.216Z",
    trimId: "string",
    uf: "string",
  };

  result: BuyPriceDetails | SellPriceDetails;

  isEvaluation = false;
  isBuyPrice = false;
  userInfo: UserInfo;

  constructor(
    private modal: MatDialogRef<EvaluationPriceModalComponent>,
    private evaluationService: EvaluationService,
    private sessionService: SessionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.vehicle = data.vehicle;
    this.isEvaluation = data.isEvaluation;
    this.isBuyPrice = data.isBuyPrice;
  }

  paginatorConfig = {
    pageSizeOptions: [5, 10, 25, 100],
    length: 0,
    pageSize: 10,
  };
  sort: Sort = null;

  page: number = 0;
  limit: number = 0;

  ngOnInit() {
    this.sessionService.getUser().subscribe((user) => {
      this.userInfo = user;
    });
  }

  filtersChanged(event) {
    this.filter = event;
    this.search();
  }
  createDateTime() {
    let arr = [];
    this.result.history.forEach((a) => {
      a.createdAt = new Date(a.createdAt);
      arr.push(a);
    });
    this.result.history = arr;
  }

  search() {
    if (!this.isBuyPrice) {
      this.evaluationService
        .sellPrice(this.vehicle.id, this.filter, this.isEvaluation)
        .subscribe((resp: SellPriceDetails) => {
          this.result = resp;
          this.result.range = this.result.soldRange;
          this.result.notRange = this.result.notSoldRange;
          this.createDateTime();
          this.sort = { active: "soldAt", direction: "desc" };

          this.sortData(this.sort);
        });
    } else {
      this.evaluationService
        .evaluationPrice(this.vehicle.id, this.filter)
        .subscribe((resp: BuyPriceDetails) => {
          this.result = resp;
          this.result.range = this.result.boughtRange;
          this.result.notRange = this.result.notBoughtRange;
          this.createDateTime();
          this.sort = { active: "date", direction: "desc" };

          this.sortData(this.sort);
        });
    }
  }
  closeModal() {
    this.modal.close();
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.result.history = this.result.history.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "year":
          return this.compare(a.manufactureYear, b.manufactureYear, isAsc);
        case "vehicle":
          return this.compare(a.model, b.model, isAsc);
        case "price":
          return this.compare(a.price, b.price, isAsc);
        case "date":
          return this.compare(a.createdAt, b.createdAt, isAsc);
        case "status":
          return this.compare(a.bought, b.bought, isAsc);
        case "soldAt":
          return this.compare(a.soldAt, b.soldAt, isAsc);
        case "initialBid":
          return this.compare(a.initialBid, b.initialBid, isAsc);
        case "margin":
          return this.compare(a.margin, b.margin, isAsc);
        case "lastBid":
          return this.compare(a.lastBid, b.lastBid, isAsc);
        default:
          return 0;
      }
    });
  }

  compare(
    a: number | string | Date | boolean,
    b: number | string | Date | boolean,
    isAsc: boolean
  ) {

    let result = 0;
    if (a === b) {
      result = 0;
    } else if (!a) {
      result = -1;
    } else if (!b) {
      result = 1;
    } else {
      result = (a < b ? -1 : 1);
    }

    return result * (isAsc ? 1 : -1);
  }

  onChangePage(values: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  }) {
    this.page = values.pageIndex;
    this.limit = values.pageSize;
  }
}
